import { createFileRoute, useParams } from '@tanstack/react-router'
import { StaffChatPage } from '@/features/staff-chat/staff-chat-page'

// The page stays mounted across its child routes, so an answer keeps streaming when a new chat
// gets its address (USA-1560).
export const Route = createFileRoute('/_authenticated/customer-comms/store-ai')({
  staticData: { title: 'Store AI' },
  component: StoreAiRoute,
})

function StoreAiRoute() {
  const { chatId } = useParams({ strict: false })
  return <StaffChatPage chatId={chatId} />
}
